import React from "react";

export const EmailFIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none">
      <path
        d="M3 8.011C2.5401 8.30488 2.16162 8.70984 1.89947 9.18853C1.63732 9.66722 1.49994 10.2042 1.5 10.75V16.75C1.5 19.65 3.85 22 6.75 22H15.75C16.9 22 17.911 21.402 18.489 20.5H6.75C5.75544 20.5 4.80161 20.1049 4.09835 19.4017C3.39509 18.6984 3 17.7446 3 16.75V8.011ZM4 8.61V16.25C3.99995 17.0801 4.31755 17.8788 4.88767 18.4822C5.45779 19.0856 6.23719 19.448 7.066 19.495L7.25 19.5H18.75C19.5801 19.5001 20.3788 19.1824 20.9822 18.6123C21.5856 18.0422 21.948 17.2628 21.995 16.434L22 16.25V8.61L13.35 13.164C13.2421 13.2209 13.122 13.2507 13 13.2507C12.878 13.2507 12.7579 13.2209 12.65 13.164L4 8.61ZM18.75 4.5H7.25C6.52428 4.49978 5.81937 4.74246 5.24759 5.18938C4.67581 5.63629 4.27006 6.26172 4.095 6.966L13 11.653L21.905 6.966C21.7376 6.29323 21.3595 5.6916 20.8259 5.24901C20.2923 4.80643 19.6311 4.54608 18.939 4.506L18.75 4.5Z"
        fill="#333333"
      />
    </svg>
  );
};
